import React from "react";
import { useHistory } from "react-router-dom";
import { Container, Box } from "@material-ui/core";
import { MinimalTopBar } from "components/MinimalTopBar";
import NotificationCard2 from "components/NotificationCard2";

export default function NotificationCard2View() {
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <Container maxWidth="sm">
      <MinimalTopBar onGoBack={handleGoBack} />
      <Box mt={3}>
        <NotificationCard2 />
      </Box>
    </Container>
  );
}
